module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/c9902-messagebox/messagebox.component.css
// module id = ./src/app/c9902-messagebox/messagebox.component.css
// module chunks = main